import { render } from "./IAP.vue?vue&type=template&id=6706d3f6&scoped=true&ts=true"
import script from "./IAP.vue?vue&type=script&lang=ts"
export * from "./IAP.vue?vue&type=script&lang=ts"

import "./IAP.vue?vue&type=style&index=0&id=6706d3f6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Edson\\Desktop\\work\\STUDOS PROD\\studiostvapp\\PlatformStudiosApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6706d3f6"]])

export default __exports__